const de = {
  title: 'Login',
  titleEmail: 'Login mit E-Mail',
  titleUserExists: 'Login mit ausgewähltem User',
  titleUserCreate: 'User erstellen',
  rememberMe: 'Eingeloggt bleiben',
  signIn: 'Hochschul-Login',
  signInExternal: 'Externer Login',
  forgot: 'Passwort vergessen?',
  alerts: {
    loginFailed: 'Der Login schlug fehl. Bitte überprüfen Sie Ihre Zugangsdaten.',
    registerSuccessful:
      'Die Registrierung war erfolgreich. Sie erhalten in Kürze eine E-Mail mit dem weiteren Vorgehen.',
    registerFailed: 'Die Registrierung konnte nicht erfolgreich durchgeführt werden.',
    confirmFailed:
      'Das Token ist leider ungültig. Fordern Sie bitte ein neues über die "Passwort vergessen"-Funktion an.',
    setPasswordSuccessful:
      'Das Passwort wurde erfolgreich gesetzt. Sie können sich nun damit einloggen.',
    setPasswordFailed: 'Das Passwort konnte nicht gesetzt werden.',
    forgotPasswordSuccessful:
      'Sofern diese E-Mail-Adresse bei uns registriert ist, sollten Sie in den nächsten Minuten eine E-Mail mit weiteren Instruktionen erhalten.',
    errorLoading: 'Fakultäten konnten nicht geladen werden.'
  },
  registerTitle: 'Registrieren',
  registerButton: 'Kostenlos Registrieren',
  formDescriptions: {
    contactData:
      'Geben Sie bitte zunächst ihre persönlichen Kontaktdaten ein. Diese werden später in den Stellenanzeigen als Kontaktdaten genannt.',
    companyData:
      'Geben Sie jetzt die Daten ihrer Firma ein. Diese werden später als allgemeine Kontaktinformationen in den Stellenanzeigen dargestellt und als Rechnungsadresse benötigt.',
    companyDescription:
      'Beschreiben Sie hier Ihre Firma in ein paar Worten. Diese Beschreibung kann auf der Profilseite ihrer Firma eingesehen werden.',
    facultyData:
      'Wählen Sie die Studiengäng aus für die Sie Stellenangebote haben. Diese können Sie später jederzeit ändern.',
    invoiceData:
      'Geben Sie bitte Rechnungsinformationen an. Falls Ihre Firmenadresse die selbe wie die Rechnungsadresse, setzen sie den zugehörigen Haken bei den Firmendaten.',
    invoiceInfo:
      'Ihre Rechnungsdaten werden nur verwendet, wenn eine kostenpflichtige Stellenanzeige aufgegeben wird. Diese sind als solche gekennzeichnet.',
    taxIdInfo: 'Ust-ID ohne Sonderzeichen/Leerzeichen',
    requiredEitherUstIdOrTaxId:
      'In Deutschland muss entweder die USt-ID oder Steuernummer angegeben werden'
  },
  formSteps: {
    contact: 'Ansprechpartner',
    company: 'Firmendaten',
    companyDescription: 'Beschreibung',
    faculties: 'Fakultäten',
    invoice: 'Rechnungsdaten'
  },
  confirmTitle: 'Passwort setzen',
  confirmDescription:
    'Die Überprüfung des Tokens war erfolgreich. Bitte geben Sie unten Ihr neues Passwort ein. Mit diesem können Sie sich fortan einloggen.',
  passwordHelperText:
    'Das Passwort muss mindestens 8 Zeichen lang sein, Großbuchstaben, mindestens eine Zahl und mindestens ein Sonderzeichen enthalten',
  forgotTitle: 'Passwort vergessen',
  forgotDescription:
    'Geben Sie Ihre E-Mail-Adresse ein. Sollte diese bei uns registriert sein, werden wir Ihnen eine E-Mail mit einem Aktivierungslink schicken.',
  processLogin: 'Ihre Login-Anfrage wird verarbeitet, bitte haben Sie einen Moment Geduld...',
  loginSelection: {
    companyLogin: {
      title: 'Unternehmen & Partner',
      description: 'Registriere dein Unternehmen und nutze den Stellenmarkt der TH Rosenheim'
    },
    universityLogin: {
      title: 'Hochschul Login',
      description: 'Für Hochschulangehörige (Studenten, Dozenten, Mitarbeiter)'
    },
    internationalOfficeLogin: {
      title: 'International Office',
      description: 'Für Austauschstudenten'
    },
    developerLogin: {
      title: 'Developer Login',
      description: 'Eigenen Benutzer zusammenbauen'
    }
  },
  or: 'Or'
};

export default de;
export type LoginTranslation = typeof de;
